import React from "react";
import styles from "../CustomComponent/EventsCards.module.scss";

interface EventCardProps {
  eventsImage: string;
  description: string;
  title?: string;
  color?: string;
}

const EventsCard: React.FC<EventCardProps> = ({
  eventsImage,
  description,
  title,
  color,
}) => {
  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div
            className={`${styles.eventsCardDiv} d-flex flex-column align-items-stretch`}
          >
            <div className={styles.eventsImageCont}>
              <img
                src={eventsImage}
                alt="Event"
                className={`${styles.eventsImage} img-fluid`}
              />
            </div>

            <div className={styles.textInfo}>
              {title && (
                <p
                  className={`${styles.title} subHeading pt-3 mb-0`}
                  style={{ color: color }}
                >
                  {title}
                </p>
              )}
              <p className={`${styles.detail} para`}>{description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventsCard;
